import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import SelectInput from '../InputComponent/SelectInput';
import TextInput from '../InputComponent/TextInput';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';

const AddPaymentModal = ({ isOpen, onClose, onSave, members, plans, isLoading }) => {
    const initialFormState = {
        memberId: '',
        planId: '',
        baseAmount: 0,
        discount: 0,
        finalAmount: 0,
        paymentMethod: 'Cash',
        transactionId: '',
        notes: '',
    };
    const [selectedMemberId, setSelectedMemberId] = useState("");
    const [selectedPlan, setSelectedPlan] = useState("");


    const [formData, setFormData] = useState(initialFormState);

    useEffect(() => {
        if (isOpen) {
            setFormData({ ...initialFormState });
        }
    }, [isOpen, members]);
 

  

    const getUserById = async (selectedMemberId) => {
        try {
            let response = await api.get(`${ENDPOINTS.getUserById}/${selectedMemberId}`);
            let user = response?.data?.user;
            console.log(user?.plan?.id);
            
            setFormData(prev => ({ ...prev, planId: user?.plan?.id , memberId:selectedMemberId}))
            // setSelectedPlan(user?.plan?.id)
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        const selectedPlan = plans.find(p => p.id == formData.planId);
        const baseAmount = selectedPlan ? selectedPlan.price : 0;
        const finalAmount = baseAmount - formData.discount;
        setFormData(prev => ({
            ...prev,
            baseAmount,
            finalAmount: finalAmount > 0 ? finalAmount : 0,
        }));
    }, [formData.planId, formData.discount, plans]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "baseAmount") {
            // allow only digits + one dot
            let cleaned = value.replace(/[^0-9.]/g, "");

            const parts = cleaned.split(".");
            if (parts.length > 2) return;

            // limit to 3 decimals
            if (parts[1] && parts[1].length > 3) {
                cleaned = parts[0] + "." + parts[1].slice(0, 3);
            }

            setFormData(prev => ({ ...prev, baseAmount: cleaned }));
            return;
        }
        if(name == 'memberId'){
            getUserById(value);
            return;
        }
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
        console.log(formData);

    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.memberId || !formData.planId) {
            toast.error('Please select a member and a plan.');
            return;
        }
        const member = members.find(m => m.id === formData.memberId);
        const plan = plans.find(p => p.id == formData.planId);

        onSave({
            memberId: formData.memberId ?? '',
            memberName: member?.name ?? '',
            planName: plan ?? {},
            amount: formData.finalAmount ?? '',
            method: formData.paymentMethod ?? '',
            transactionId: formData.transactionId,
            notes: formData.notes,
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Add New Payment">
            <form onSubmit={handleSubmit} className="space-y-4">
                <SelectInput label={"Member"} name="memberId" value={formData.memberId} onChange={handleChange} isRequired={true}>
                    <option value="">Select Member</option>
                    {members.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                </SelectInput>
                <SelectInput label={"Plan"} name="planId" value={formData.planId} onChange={handleChange} isRequired={true}>
                    <option value="">Select Plan</option>
                    {plans.filter(p => p.status === 'active').map(p => <option key={p.id} value={p.id}>{p.name} - {p.price.toFixed(3)} OMR</option>)}
                </SelectInput>
                <div className="grid grid-cols-2 gap-4">
                    <TextInput label={"Base Amount (OMR)"} type="text" name={"baseAmount"} value={`${formData.baseAmount}`} onChange={handleChange} isRequired={true} isPriceInput={true} />
                    <TextInput label={"Discount (OMR)"} type="text" name="discount" value={formData.discount} onChange={handleChange} min="0" step="0.001" />
                </div>
                <TextInput label={"Final Amount"} type="number" value={`${formData.finalAmount}`} disabled />

                <SelectInput label={"Payment Method"} name="paymentMethod" value={formData.paymentMethod} onChange={handleChange} >
                    <option>Cash</option>
                    <option>Card</option>
                    <option>Online</option>
                </SelectInput>
                <TextInput label={"Transaction ID"} type="text" name="transactionId" value={formData.transactionId} onChange={handleChange} />

                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button disabled={isLoading} type="submit" className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">{isLoading ? 'Loading..' : 'Record Payment'}</button>
                </div>
            </form>
        </Modal>
    );
};

export default AddPaymentModal;
